import { render } from "./ItemPedido.vue?vue&type=template&id=60df42f2&scoped=true"
import script from "./ItemPedido.vue?vue&type=script&lang=js"
export * from "./ItemPedido.vue?vue&type=script&lang=js"

import "./ItemPedido.vue?vue&type=style&index=0&id=60df42f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60df42f2"]])

export default __exports__